import { formatCopy } from '../copy/format.js';
import copy from '../copy/en/intake.json' with { type: 'json' };
import { DATA_STAGES } from "./flow.js";
import { formatPhone } from "./masks.js";

function fieldLabel(form: HTMLFormElement, name: string): string {
  const control = form.querySelector<HTMLElement>(`[name="${name}"]`);
  const field = control?.closest(".field");
  const label = field?.querySelector(":scope > span")
    ?? control?.closest("fieldset")?.querySelector(":scope > legend");
  const labelText = label?.cloneNode(true) as HTMLElement | undefined;
  labelText?.querySelectorAll('.optional').forEach(element => element.remove());
  return labelText?.textContent?.trim()
    || name.replace(/([A-Z])/g, " $1");
}

/** Render only captured request values; never interpret profile answers as legal terms. */
export function renderReview(
  target: HTMLElement,
  form: HTMLFormElement,
  data: Readonly<Record<string, string>>,
): void {
  const sections = DATA_STAGES.map((stage, index) => {
    const section = document.createElement("details");
    section.className = "review-group";
    const heading = document.createElement("summary");
    heading.textContent = stage.label;
    section.append(heading);
    const body = document.createElement("div");
    body.className = "review-group-body";
    const edit = document.createElement("button");
    edit.type = "button";
    edit.className = "btn btn-ghost btn-small";
    edit.dataset.editStage = String(index);
    edit.textContent = formatCopy(copy.editSection, { section: stage.label.toLowerCase() });
    body.append(edit);
    if (index >= 2) {
      const note = document.createElement("p");
      note.className = "group-intro";
      note.textContent = copy.practiceProfileForOHFStaffTheseAnswers;
      body.append(note);
    }
    const list = document.createElement("dl");
    list.className = "review-summary";
    for (const name of stage.fields) {
      const value = data[name]?.trim();
      // Hide dependent Other details and empty optional fields, not required identities.
      if (!value) continue;
      const dependent = form.querySelector(`[name="${name}"]`)?.closest<HTMLElement>("[data-other-for]");
      if (dependent && !(data[dependent.dataset.otherFor ?? ""] ?? "").split(/[,;]/).map((item) => item.trim()).includes(dependent.dataset.otherWhen ?? "Other")) continue;
      const row = document.createElement("div");
      const label = document.createElement("dt");
      label.textContent = fieldLabel(form, name);
      const answer = document.createElement("dd");
      answer.dataset.reviewField = name;
      answer.textContent = name === "phone" || name === "mobilePhone" ? formatPhone(value) : value;
      row.append(label, answer);
      list.append(row);
    }
    if (list.childElementCount) body.append(list);
    else {
      const empty = document.createElement("p");
      empty.className = "group-intro";
      empty.textContent = copy.noOptionalInformationProvided;
      body.append(empty);
    }
    section.append(body);
    return section;
  });
  const highlights = document.createElement("dl");
  highlights.className = "review-summary";
  highlights.setAttribute("aria-label", copy.agreementDetails);
  for (const [name, labelText] of [["practiceName", copy.practice], ["legalCompanyName", copy.legalBusiness], ["signerName", copy.signer], ["email", copy.email]]) {
    const row = document.createElement("div");
    const label = document.createElement("dt");
    label.textContent = labelText;
    const value = document.createElement("dd");
    value.textContent = data[name] || "—";
    row.append(label, value);
    highlights.append(row);
  }
  const hint = document.createElement("p");
  hint.className = "group-intro";
  hint.textContent = copy.expandASectionToCheckAllYour;
  target.replaceChildren(highlights, hint, ...sections);
}
